var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookshelf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11h16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16h16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4v7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4v7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16v4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11v5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20v1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20v1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookshelf);
export default __webpack_public_path__ + "static/media/bookshelf.fb20d15a2c5652b96dc1dd19f94d01e2.svg";
export { ForwardRef as ReactComponent };